function loadRecaptcha() {			
	var head = document.head.innerHTML;
	var check = head.search("https://www.google.com/recaptcha/api.js")	
	var spam = document.querySelector('.form_spam');
	if (check === -1) {
		var recapScript = document.createElement("script");
		recapScript.type = "text/javascript";
		recapScript.src = "https://www.google.com/recaptcha/api.js"; 
		document.getElementsByTagName("head")[0].appendChild(recapScript);
		return false;		
	}
	spam.classList.add('shown');
}